export const addressValidationErrorField = 'line_1'

export const addressValidationErrorMessages = {
  ADDRESS_TOO_LONG: 'La dirección es demasiado larga.',
  HOUSE_NUMBER_TOO_LONG: 'El número es demasiado largo.',
  HOUSE_NUMBER_TOO_SHORT: 'El número es demasiado corto.',
  ADDRESS_NOT_VALID: 'No hemos podido encontrar esta dirección. Compruébala e inténtalo de nuevo.',
}
